import clsx from "clsx";

import { Button } from "@shared/buttons/button";

import { useSelectedMediaPlanModal } from "../use-selected-media-plan-modal";

type Props = {
  className?: string;
  verify?: () => void;
  unverify?: () => void;
  isLoading?: boolean;
  children?: React.ReactNode;
  isVerified: boolean;
};

export const MediaPlanVerifyButton = ({
  className,
  verify,
  unverify,
  isLoading,
  children,
  isVerified,
}: Props) => {
  const { isDraft } = useSelectedMediaPlanModal();

  if (!isDraft) {
    return null;
  }

  return (
    <div
      className={clsx(
        "flex items-center",
        { "justify-end": isVerified, "justify-between": !isVerified },
        className,
      )}
    >
      {!isVerified && children}
      {isVerified ? (
        <Button
          className="bg-sun text-white font-bold"
          disabled={false}
          onClick={unverify}
          loading={isLoading}
          isDisabled={isLoading}
        >
          MAKE CHANGES
        </Button>
      ) : (
        <Button
          className="bg-alien text-white font-bold"
          disabled={false}
          onClick={verify}
          loading={isLoading}
          isDisabled={isLoading}
        >
          EVERYTHING LOOKS GOOD
        </Button>
      )}
    </div>
  );
};
